import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import {
	Avatar,
	Button,
	GraphQLErrorMessage,
	Modal,
	Paragraph,
	Pill,
	Spinner,
} from '@treams/treams-ui';

import { formatRevealValue } from './formatRevealValue';

interface IProps {
	evaluationFormID: string;
	onClose: () => void;
}

export function ConversationRevealDataPreview({ evaluationFormID, onClose }: IProps) {
	const { t, i18n } = useTranslation();

	const { data, loading, error } = graphql.useEvaluationFormRevealUploadDataQuery({
		variables: { id: evaluationFormID },
		fetchPolicy: 'cache-and-network',
	});

	const upload = data?.evaluationForm.revealUpload;

	return (
		<Modal width={640}>
			<Modal.Header title={t('conversations.reveal.settings.previewTitle')} onClose={onClose} />
			<Modal.Contents>
				{error && <GraphQLErrorMessage error={error} />}
				{loading && !upload && (
					<Flex justifyContent="center" p={4}>
						<Spinner />
					</Flex>
				)}
				{upload && (
					<Box style={{ maxHeight: 400, overflowY: 'auto' }}>
						{upload.matchedUsers.map((entry) => (
							<Flex key={entry.user.id} alignItems="center" mb={2} style={{ gap: 8 }}>
								<Avatar user={entry.user} size={24} />
								<Paragraph>{entry.user.fullName}</Paragraph>
								<Flex flexWrap="wrap" style={{ gap: 4 }}>
									{entry.values.map((field) => (
										<Pill key={field.label} small>
											{field.label}: {formatRevealValue(field, i18n.language)}
										</Pill>
									))}
								</Flex>
							</Flex>
						))}
					</Box>
				)}
			</Modal.Contents>
			<Modal.Footer>
				<Flex justifyContent="flex-end">
					<Button small type="secondary" title={t('common.close')} onClick={onClose} />
				</Flex>
			</Modal.Footer>
		</Modal>
	);
}
